import { createSlice } from '@reduxjs/toolkit'

import { ALMDeposits } from './types'

export interface UserPositionDataState {
  kodiakIslandUserDepositUSD: ALMDeposits
}

export const initialState: UserPositionDataState = {
  kodiakIslandUserDepositUSD: {},
}

const userPositionDataSlice = createSlice({
  name: 'userPositionData',
  initialState,
  reducers: {
    updateIslandDepositsUSD(state, { payload: { islandId, updatedAmount } }) {
      state.kodiakIslandUserDepositUSD[islandId] = updatedAmount
    },
  },
})

export const { updateIslandDepositsUSD } = userPositionDataSlice.actions
export default userPositionDataSlice.reducer
